import React from 'react'

const Textarea = ({ name, index, value, title, validate, change, type, placeholder}) => {
  return (
    <React.Fragment>
      <label htmlFor={`${name}-field-${index}`} className="block text-sm font-semibold text-red mb-5">{title}{ validate && validate.required ? ' *' : '' }</label>
      <textarea autoComplete="off" id={`${name}-field-${index}`} value={value} className="text-input w-full max-w-sm2 border rounded-md h-48 border-grey-darker h-18 px-6 pt-8 md:text-lg text-sm font-medium text-black" type={type} placeholder={placeholder} name={name} onChange={ (e) => change(index, e.target.value)} />
    </React.Fragment>
  )
}

export default Textarea
